<template>
  <div v-if="hasGoogleMaps">
    <gmap-map :center="marker" :zoom="16" style="width: 100%; height: 400px">
      <gmap-marker :position="marker" />
    </gmap-map>
  </div>
</template>

<script>
import GoogleApiService from '_services/common/googleApiService';

export default {
  name: 'GoogleMap',
  props: {
    lat: {
      type: String,
      required: true,
    },
    lng: {
      type: String,
      required: true,
    },
  },
  computed: {
    marker() {
      return {
        lat: parseFloat(this.lat),
        lng: parseFloat(this.lng),
      };
    },
    hasGoogleMaps() {
      return !!GoogleApiService.getApiKey();
    },
  },
};
</script>
